import { VendorProductDetailPage } from "@/features/vendor-app/pages/VendorProductDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/products/$productID")({
	component: VendorProductDetailPage,
});
